module.exports = __webpack_public_path__ + "static/media/iguazu-falls-7.82d12e45.jpg";